export type DimensionData = {
  costCenter: Map<string, { name: string }>;
  expenseCategory: Map<string, { name: string }>;
  supplier: Map<string, { name: string; thumbnailUrl: string | undefined }>;
};

/**
 * Get the human-readable label for a dimension value
 */
export const getDimensionLabel = (
  dimension: keyof DimensionData,
  valueId: string,
  dimensionData: DimensionData,
): string => dimensionData[dimension].get(valueId)?.name ?? valueId;
